<template>
  <footer>
    <div id="footer" class="container">
      <div class="row">
        <div class="col-md-6">
          <router-link to="/">
            <img :src="partner.logo_url" class="partner-logo"/>
          </router-link>
          <div class="row mt-5">
            <div class="col-md-5 title-footer" v-if="!user.signed()">
              <button class="btn-login" @click="signIn()">
                {{$t("menu.login")}}
              </button>
            </div>
            <div class="col-md-2 title-footer mt-10">
              <router-link class="title-footer" to="/events">
                {{$t("menu.events")}}
              </router-link>
            </div>
            <div class="col-md-2 title-footer mt-10">
              <router-link class="title-footer" to="/contact">
                {{$t("menu.contact")}}
              </router-link>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-sm-2 col-4" v-if="partner.hasFacebook()">
              <div class="social-circle">
                <a :href="partner.facebook_url" target="_blank">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </div>
            </div>
            <div class="col-sm-2 col-4" v-if="partner.hasInstagram()">
              <div class="social-circle">
                <a :href="partner.instagram_url" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>
            </div>
            <div class="col-sm-2 col-4" v-if="partner.hasTwitter()">
              <div class="social-circle">
                <a :href="partner.twitter_url" target="_blank">
                  <i class="fa-brands fa-x-twitter"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12 powered">
          <p>{{$t("footer.powered")}}</p>
          <a href="https://www.chuspic.com/" target="_blank">
            <img src="../images/logo/logo.png" />
          </a>
        </div>
        <div class="col-md-12 footer-links">
          <ul class="list-inline">
            <li class="list-inline-item">
              <router-link to="/terms-conditions">
                {{$t("footer.conditions")}}
              </router-link>
            </li>
            <li class="list-inline-item separator">|</li>
            <li class="list-inline-item">
              <router-link to="/privacy-policies">
                {{$t("footer.privacy")}}
              </router-link>
            </li>
            <li class="list-inline-item separator">|</li>
            <li class="list-inline-item">
              {{$t("footer.copyright")}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Partner from "../models/Partner"
import User from "../models/User"

export default {
  name: "Footer",
  data() {
    return {
      partner: new Partner(),
      user: new User()
    }
  },
  mounted() {
    this.$root.$on('setPartner', this.setPartner)
    this.$root.$on('setUser', this.setUser)
  },
  methods:{
    signIn() {
      this.$root.$emit('openSignIn')
    },
    setPartner(partner) {
      this.partner = partner
    },
    setUser(user) {
      this.user = user
    }
  }
}
</script>

<style lang="scss">
  @import '../scss/variables.scss';

  footer {
    background: $primary-darken1;
    width: 100%;
    #footer {
      padding: 70px 40px 40px 40px;
    }
    .btn-login {
      color: $primary-base;
      background: $secondary-base;
      border: 1px solid $secondary-base;
      border-radius: 100px;
      padding: 10px 20px;
      font-family: $font-bold;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      text-align: center;
    }
    .partner-logo {
      height: 60px;
    }
    .powered {
      text-align: right;
      p {
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        text-align: right;
        color: #FFFFFF;
        margin-right: 20px;
      }
    }

    @media screen and (max-width: 600px) {
      .powered {
        text-align: center;
        p {
          text-align: center;
          margin-right: 0;
        }
      }
    }
  }
  .title-footer {
    color: $accent-darken1;
    font-family: $font-light;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    text-decoration: none;
    text-align: center;
  }
  .social-circle {
    background: $accent-darken1;
    border-radius: 40px;
    text-align: center;
    width: 54px;
    height: 54px;
    i {
      color: $primary-darken1;
      padding: 20px;
      font-size: 28px;
      width: 70px;
      border-radius: 50%;
      text-decoration: none;
      margin: -7px;
      cursor: pointer;
    }
  }
  .footer-links {
    color: $accent-darken1 !important;
    font-size: 14px;
    line-height: 16px;
    a {
      color: $accent-darken1 !important;
    }
  }

  @media screen and (max-width: 600px) {
    footer {
      .btn-login {
        margin: auto;
      }
    }
  }

</style>
